import * as d3 from 'd3';

const line = {
  id: 'line',
  label: 'Line',
  // Line mode scales to closes only (tighter, more focused range) --
  // matches TradingView's own line-mode behavior, distinct from the
  // high/low-aware candle/bar/HA modes.
  getYExtent(data) {
    return d3.extent(data, (d) => d.close);
  },
  draw({ group, data, xScale, yScale, theme }) {
    const gen = d3
      .line()
      .x((d) => xScale(d.date))
      .y((d) => yScale(d.close))
      .curve(d3.curveMonotoneX);

    group
      .selectAll('.mark-line')
      .data([data])
      .join('path')
      .attr('class', 'mark-line')
      .attr('fill', 'none')
      .attr('stroke', theme.primaryLine)
      .attr('stroke-width', 2)
      .attr('stroke-linejoin', 'round')
      .attr('d', gen);
  },
  tooltipFields(d) {
    return { open: d.open, high: d.high, low: d.low, close: d.close, volume: d.volume };
  },
};

export default line;
